import React from 'react';
import { TextField, useTranslate, FieldProps, useRecordContext } from 'react-admin';

interface EnumTextFieldProps extends FieldProps {
  source: string;
  translationKeyPrefix: string;
  emptyText?: string;
}

const EnumTextField: React.FC<EnumTextFieldProps> = (props) => {
  const { source, translationKeyPrefix, emptyText = '', ...rest } = props;
  const record = useRecordContext(props);
  const translate = useTranslate();

  if (!record) return null;

  const value = record[source];
  if (value === null || value === undefined) {
    return <span>{emptyText}</span>;
  }

  const statusKey = `${translationKeyPrefix}.${value}`;
  const translatedText = translate(statusKey);
  return <TextField {...rest} source={source} record={{ ...record, [source]: translatedText }} />;
};

export default EnumTextField;
